import * as React from "react";

import Modal from "react-modal";

import { IServer } from "../../classes/state";
import { IText } from "../../classes/text";

import { LoadingSpinner } from "../../../Common/LoadingSpinner/LoadingSpinner";
import { ModalHtmlClassHack } from "../../../common/modalHtmlClassHack/ModalHtmlClassHack";
import { SelectEventsControl } from "./SelectEventsControl";

export interface ISelectEventsModal {
	calendarId: number;
	childServerIds: number;
	currentServerId: number;
	parentServerId: number;
	numAjaxCallsInProgress: number;
	portletInstanceId: number;
	rootServerId: number;
	displayModal: boolean;
	servers: IServer[];
	checkedNodeItemIds: string[];
	checkedNodeCalendarIds: string[];
	expandedNodeItemIds: string[];
	text: IText;
	currentPageNumber: number;
	onCloseModal: (event: any) => any;
	updateCheckedNodeItemIds(checkedNodeItemIds: string[]): void;
	updateCheckedNodeCalendarIds(checkedNodeCalendarIds: string[]): void;
	updateExpandedNodeItemIds(expandedNodeItemIds: string[]): void;
	updateServersSitesPagesAndCalendars(servers: IServer[]): void;
	updateCurrentPageNumber(pageNumber: number): void;
}

export class SelectEventsModal extends React.Component<ISelectEventsModal, any> {

	private parentElementSelector = "#portlet" + this.props.portletInstanceId + ".PO-calendar";

	constructor(props, context) {
		super(props, context);
	}

	public componentDidMount() {
		Modal.setAppElement(this.parentElementSelector);
	}

	public render() {

		const props = this.props;

		const getParent = () => {
			return document.querySelector(this.parentElementSelector);
		};

		const onClickCloseModalButton = (event: any) => {
			event.preventDefault();
			props.onCloseModal(event);
		};

		// Loading and classnames:
		const isLoading = this.props.numAjaxCallsInProgress > 0;
		const loadingEventsText = this.props.text.eventViews.loadingEvents;
		const selectEventsFromOtherCalendarsText = this.props.text.selectEvents.selectEventsFromOtherCalendars;
		const closeText = this.props.text.selectEvents.close;

		return (
			<React.Fragment>

				<ModalHtmlClassHack modalIsOpen={props.displayModal} />

				<Modal
					isOpen={props.displayModal}
					parentSelector={getParent}
					shouldCloseOnOverlayClick={true}
					className={"ReactModal__Content"}
					overlayClassName={"ReactModal__Overlay CMS_PF_dialog CMS_PF_react CMS_react_ScrollingDialog"}
					onRequestClose={props.onCloseModal}
				>
					<React.Fragment>
						<div className="CAL_modalHeader">
							<em className="fa fa-calendar" aria-hidden="true"></em> {selectEventsFromOtherCalendarsText}
							<a href="#" onClick={onClickCloseModalButton} className="CMS_dialogClose CMS_button CMS_bSquare CMS_bCancel"><em className="fa fa-times" aria-hidden="true"></em><span className="offScreen">{closeText}</span></a>
						</div>

						<div className="CAL_modalContent CMS_minimumHeight">

							{isLoading &&
								<LoadingSpinner showSpinner={true} loadingText={loadingEventsText} />
							}

							{!isLoading &&
								<SelectEventsControl
									calendarId={props.calendarId}
									childServerIds={props.childServerIds}
									currentServerId={props.currentServerId}
									parentServerId={props.parentServerId}
									portletInstanceId={props.portletInstanceId}
									rootServerId={props.rootServerId}
									servers={props.servers}
									checkedNodeItemIds={props.checkedNodeItemIds}
									checkedNodeCalendarIds={props.checkedNodeCalendarIds}
									expandedNodeItemIds={props.expandedNodeItemIds}
									text={props.text}
									currentPageNumber={props.currentPageNumber}
									onCloseModal={props.onCloseModal}
									updateCheckedNodeItemIds={props.updateCheckedNodeItemIds}
									updateCheckedNodeCalendarIds={props.updateCheckedNodeCalendarIds}
									updateExpandedNodeItemIds={props.updateExpandedNodeItemIds}
									updateServersSitesPagesAndCalendars={props.updateServersSitesPagesAndCalendars}
									updateCurrentPageNumber={props.updateCurrentPageNumber}
								/>
							}

						</div>

					</React.Fragment>
				</Modal>

			</React.Fragment>
		);

	}
};
